import { render } from "./BlogInOnLaysNot.vue?vue&type=template&id=52faa142"
import script from "./BlogInOnLaysNot.vue?vue&type=script&lang=js"
export * from "./BlogInOnLaysNot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__